import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, Subject} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {DOCUMENT} from '@angular/common';

declare const samp: any;

const sampMetadata = {samp: {name: 'ALMA Science Archive', description: 'ALMA Science Archive'}};
const voTablesEndpoint = 'service/api/v1/votables';

interface SampFile {
  readonly name: string;
}

@Injectable({
  providedIn: 'root'
})
export class SampService {
  private readonly sampConnector = new samp.Connector('ALMA Science Archive', sampMetadata);

  private sampError = new Subject<any>();
  private voTablesUrl;

  constructor(@Inject(DOCUMENT) private readonly document: Document,
              private readonly httpClient: HttpClient) {
    const baseUrl = `${this.document.location.origin}${this.document.location.pathname}`;

    this.voTablesUrl = `${baseUrl}${voTablesEndpoint}`;
  }

  sendToSamp(content: string): Observable<any> {
    return of(content).pipe(
      switchMap(voTable => this.httpClient.post<SampFile>(this.voTablesUrl, voTable)),
      map(sampFile => this.sendRowsToSampHub(sampFile))
    );
  }

  getSampError(): Observable<any> {
    return this.sampError.asObservable();
  }

  setSampError(error: string): void {
    this.sampError.next(error);
  }

  private sendRowsToSampHub(sampFile: SampFile): void {
    const msg = new samp.Message('table.load.votable', {
      url: `${this.voTablesUrl}/${sampFile.name}`,
      name: sampMetadata.samp.name
    });

    const connHandler = (connection) => connection.notifyAll([msg]);
    const regErrorHandler = (error) => this.setSampError(error?.toString());

    this.sampConnector.runWithConnection(connHandler, regErrorHandler);
  }
}
